import { useEffect, useState } from "react";
import DashboardShell from "@/components/layout/DashboardShell";
import { api } from "@/lib/api";
import { OrdersPanel, fmtMoney } from "@/components/feed/feedShared";

export default function HelperFeed() {
  const [kpi, setKpi] = useState(null);
  useEffect(() => {
    api.get("/feed/dashboard").then((r) => setKpi(r.data)).catch(() => {});
  }, []);
  const chips = kpi && [
    ["Today's Orders", `${kpi.today_orders.count} · ${fmtMoney(kpi.today_orders.amount)}`],
    ["Unpaid Orders", `${kpi.unpaid_orders.count} · ${fmtMoney(kpi.unpaid_orders.amount)}`],
    ["Products", kpi.direct_products + kpi.marketplace_products],
  ];
  return (
    <DashboardShell title="Feed & Fodder" subtitle="Take feed orders at the haat">
      <div className="space-y-5" data-testid="helper-feed-page">
        {chips && (
          <div className="grid grid-cols-3 gap-3" data-testid="helper-feed-kpis">
            {chips.map(([label, value]) => (
              <div key={label} className="am-card p-3.5">
                <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{label}</div>
                <div className="font-display text-lg font-extrabold mt-0.5">{value}</div>
              </div>
            ))}
          </div>
        )}
        <OrdersPanel />
      </div>
    </DashboardShell>
  );
}
